import Errors from './StandardErrors'

export default class CustomNodeErrors extends Errors {
  record (errors, prefix = undefined) {
    let aux = {}
    errors.forEach(element => {
      aux[element.param] = `${prefix || ''}${element.msg.replace(/ /g, '_').toLowerCase()}`
    })
    this.errors = aux
  }
}
